module.exports = __webpack_public_path__ + "374d369eeecdafc41a17099a010a3d5b.fbx";